import "./FiltrosGerenciaAnimais.css"
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import React from 'react';

import { logout } from "../../auth";
import { get, post } from '../../services/api';

function FiltrosGerenciaAnimais({ filtros, setFiltros, setMetas, refetchMetas }) {
    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';
    const [ authTokenState, setAuthTokenState ] = useState(undefined)
    
    const [ optionsRegioes, setOptionsRegioes ] = useState([])
    const [ optionsFiliais, setOptionsFiliais ] = useState([])
    const [ optionsPeriodos, setOptiosPeriodos ] = useState([])
    const [ optionsTipos, setOptionsTipos ] = useState([])

    const [ regiaoSelected, setRegiaoSelected ] = useState(null)
    const [ filialSelected, setFilialSelected ] = useState(null)
    const [ periodoSelected, setPeriodoSelected ] = useState(null)
    const [ tipoSelected, setTipoSelected ] = useState(null)

    const selectStyle = {
        control: (base) => ({
            ...base,
            background: 'unset',
            borderColor: '#DCDCDC',
            borderRadius: '4px',
            fontSize: '14px',
            minHeight: '38px',
            height: 'auto',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#BFBFBF',
            },
        }),
    };
    

    const navigate = useNavigate(); 

    async function setOptionsRegioesWithRequest() {
        try {
            const requisicao = { idFilial: 0 } //Todas as regioes
            const regioes = await post('/vendedores/regioes', requisicao);

            setOptionsRegioes(regioes.map(regiao => { 
                return { label: regiao.nome_regiao, value: regiao.id_regiao } 
            }))
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsFiliaisWithRequest() {
        try {
            const requisicao = { idRegiao: 0 } //Todas as filiais
            const filiais = await post('/vendedores/filiais', requisicao);

            filiais.forEach(filial => filial.nome = `${filial.nome} - ${filial.cod_sabium - 10000}` )
            
            setOptionsFiliais(filiais)
            return filiais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsPeriodosWithRequest(authToken, idfilial, id_tipo_metas) {
        try {
            const periodos = await get(`/admin/metas/periodos?idfilial=${idfilial}&id_tipo_metas=${id_tipo_metas}`, null, authToken);

            setOptiosPeriodos(periodos.map(periodo => {
                return { label: periodo.label, value: periodo.value }
            }))
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsTiposWithRequest(authToken) {
        try {
            const tipos = await get('/admin/metas/tipo', null, authToken);

            setOptionsTipos(tipos.map(tipo => {
                return { value: tipo.id_tipo_metas, label: tipo.descricao }
            }))

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    
    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }
        setAuthTokenState(authToken)

        setOptionsRegioesWithRequest()
        setOptionsFiliaisWithRequest()
        setOptionsTiposWithRequest(authToken)
    }, [])

    return (
        <div className="filtros-consulta-wrapper">
            <div className="header">
                <span>1</span>
                <h1>Selecione os filtros</h1>
            </div>
            <div className="body">
                <div className='regiao-wrapper'>
                    <label htmlFor="regiao">Selecione a região</label>
                    <Select
                        name="regiao"
                        id="regiao"
                        value={regiaoSelected}
                        onChange={(option) => {
                            setRegiaoSelected(option);
                            setFilialSelected(null);
                            setOptiosPeriodos([]);
                            setPeriodoSelected(null);
                            setFiltros((oldFiltros) => ({
                                ...oldFiltros,
                                idfiliais: null,
                                mes: null,
                                ano: null,
                            }));
                            setMetas([]);
                        }}
                        options={[{ label: 'Todas', value: undefined }, ...optionsRegioes]}
                        isClearable={false}
                        styles={selectStyle}
                        placeholder="Região"
                        isSearchable={false}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuShouldScrollIntoView={false}  
                    />
                </div>
                <div className='filial-wrapper'>
                    <label htmlFor="filial">Selecione a filial</label>
                    <Select
                        name="filial"
                        id="filial"
                        value={filialSelected}
                        onChange={(option) => { 
                            setFilialSelected(option) 

                            if(tipoSelected?.value != null) 
                                setOptionsPeriodosWithRequest(authTokenState, option.value, tipoSelected.value)
                            setPeriodoSelected(null)

                            setFiltros(oldFiltros => ({
                                ... oldFiltros,
                                idfiliais: [option.value],
                                mes: null,
                                ano: null
                            }))

                            setMetas([])
                        }}
                        options={
                            (regiaoSelected?.value
                                ? optionsFiliais.filter(filial => filial.id_regiao === regiaoSelected.value)
                                : optionsFiliais)
                            .map(filial => {
                                return { label: filial.nome, value: filial.cod_sabium }
                            })
                        }
                        isClearable={false}
                        styles={selectStyle}
                        placeholder="Filial"
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuShouldScrollIntoView={false} 
                    />
                </div>
                <div className='tipo-wrapper'>
                    <label htmlFor="tipo">Selecione o tipo</label>
                    <Select
                        name="tipo"
                        id="tipo"
                        value={tipoSelected}
                        onChange={(option) => { 
                            setTipoSelected(option) 

                            if(filialSelected?.value != null) 
                                setOptionsPeriodosWithRequest(authTokenState, filialSelected.value, option.value)
                            setPeriodoSelected(null)

                            setFiltros(oldFiltros => ({ 
                                ... oldFiltros, 
                                id_tipo_metas: option.value,
                                mes: null,
                                ano: null 
                            }))

                            setMetas([])
                        }}
                        options={optionsTipos}
                        styles={selectStyle}
                        placeholder="Tipo"
                        isSearchable={false}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                    />
                </div>
                <div className={`periodo-wrapper ${optionsPeriodos.length < 1 ? 'disabled' : ''}`}>
                    <label htmlFor="periodo">Selecione o período</label>
                    <Select
                        name="periodo"
                        id="perido"
                        value={periodoSelected}
                        onChange={(option) => { 
                            setPeriodoSelected(option) 

                            const [ mes, ano ] = option.value.split('-')
                            setFiltros(oldFiltros => ({ 
                                ... oldFiltros,
                                mes: mes,
                                ano: ano
                             }))

                             setMetas([])
                        }}
                        options={optionsPeriodos}
                        isClearable={false}
                        styles={selectStyle}
                        placeholder="Período"
                        isSearchable={false}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuShouldScrollIntoView={false}  
                    />
                </div>
                
                <div>
                    <button 
                        className="load-metas-btn"
                        disabled={
                            !filtros.idfiliais || 
                            !filtros.id_tipo_metas || 
                            !filtros.mes || 
                            !filtros.ano
                        } onClick={() => refetchMetas(filtros)}>Carregar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FiltrosGerenciaAnimais